import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Text } from 'foundations-components/components/Text';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import SummaryEmptyTable from './SummaryEmptyTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SummarySearchFailure() {
  return /*#__PURE__*/_jsxs(SummaryEmptyTable, {
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "SUMMARY_FAIL"
    }), /*#__PURE__*/_jsx(TFlex, {
      align: "center",
      direction: "column",
      padding: "1000",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexDirection: "column",
        inlineSize: "400px",
        children: [/*#__PURE__*/_jsx(Illustration, {
          name: "errors/general",
          width: 150,
          marginBlockStart: "600",
          marginBlockEnd: "300"
        }), /*#__PURE__*/_jsx(Text, {
          as: "h4",
          textAlign: "center",
          marginBlockEnd: "300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "summary.searchFailure.unableToComplete"
          })
        }), /*#__PURE__*/_jsx(Text, {
          textAlign: "center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "summary.searchFailure.moreSpecificQuery"
          })
        })]
      })
    })]
  });
}